import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/caduceo.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-246ba7ea"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "grid-item"
};
var _hoisted_2 = {
    key: 0,
    src: _imports_0,
    height: "10",
    width: "50"
};
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "plus" }, null, -1); });
var _hoisted_4 = {
    key: 1,
    class: "title"
};
var _hoisted_5 = { class: "titlenote" };
var _hoisted_6 = {
    key: 2,
    class: "title"
};
var _hoisted_7 = {
    key: 3,
    class: "title"
};
var _hoisted_8 = { key: 1 };
var _hoisted_9 = { key: 4 };
var _hoisted_10 = { class: "title" };
var _hoisted_11 = { class: "titlenote" };
var _hoisted_12 = { key: 0 };
var _hoisted_13 = { key: 1 };
var _hoisted_14 = { key: 2 };
var _hoisted_15 = { key: 5 };
var _hoisted_16 = {
    key: 0,
    class: "title"
};
var _hoisted_17 = { class: "titlenote" };
var _hoisted_18 = { key: 0 };
var _hoisted_19 = { key: 1 };
var _hoisted_20 = { key: 2 };
var _hoisted_21 = {
    key: 6,
    class: "date-disc"
};
var _hoisted_22 = { class: "title" };
var _hoisted_23 = { key: 0 };
var _hoisted_24 = { key: 1 };
var _hoisted_25 = { class: "titlenote" };
var _hoisted_26 = {
    key: 2,
    class: "titlenote"
};
var _hoisted_27 = {
    key: 7,
    class: "date-disc"
};
var _hoisted_28 = { class: "title" };
var _hoisted_29 = { key: 0 };
var _hoisted_30 = { key: 1 };
var _hoisted_31 = { key: 0 };
var _hoisted_32 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_33 = { style: { "font-size": "15px" } };
var _hoisted_34 = { key: 1 };
var _hoisted_35 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_36 = { style: { "font-size": "15px" } };
var _hoisted_37 = { key: 2 };
var _hoisted_38 = { key: 0 };
var _hoisted_39 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_40 = { style: { "font-size": "15px" } };
var _hoisted_41 = {
    key: 8,
    class: "date-disc"
};
var _hoisted_42 = { class: "title" };
var _hoisted_43 = { key: 0 };
var _hoisted_44 = {
    key: 1,
    style: { "margin-left": "-5em" }
};
var _hoisted_45 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_46 = { style: { "font-size": "15px" } };
var _hoisted_47 = {
    key: 9,
    class: "date-disc"
};
var _hoisted_48 = { class: "title" };
var _hoisted_49 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_50 = { class: "titlenote" };
var _hoisted_51 = { key: 0 };
var _hoisted_52 = { key: 1 };
var _hoisted_53 = {
    key: 10,
    class: "date-disc"
};
var _hoisted_54 = { class: "title" };
var _hoisted_55 = { key: 0 };
var _hoisted_56 = { key: 0 };
var _hoisted_57 = { key: 1 };
var _hoisted_58 = {
    key: 1,
    class: "horizontalLineSmall"
};
var _hoisted_59 = {
    key: 2,
    class: "grid-item"
};
var _hoisted_60 = {
    class: "column",
    style: { "display": "flex", "align-items": "center", "justify-content": "center" }
};
var _hoisted_61 = {
    key: 0,
    class: "title"
};
var _hoisted_62 = {
    key: 1,
    class: "title"
};
var _hoisted_63 = {
    key: 2,
    class: "titlenote"
};
var _hoisted_64 = {
    key: 3,
    class: "titlenote"
};
import { patientStore } from "@/store/patient";
import CollapsibleRowActions from "@/layout/collapsible/CollapsibleRowActions.vue";
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollapsibleRow',
    props: {
        row: Object,
        data: Object,
    },
    emits: ["rowActions"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var store = patientStore();
        var layoutType = (function () {
            var _a;
            var type = (_a = props.data) === null || _a === void 0 ? void 0 : _a.data;
            if (['contattiemergenza', 'contattialtro'].includes(type))
                return 'contatti';
            if (['visite'].includes(type))
                return 'visite';
            if (type === 'tbl_parametri_vitalis')
                return 'rilevazioni';
            if (type === 'associated_doctors')
                return 'associati';
            if (type === 'avalailable_doctors')
                return 'disponibili';
            if (type === 'diagnosi')
                return 'diagnosi';
            if (type === 'tbl_terapie')
                return 'farmaci';
            if (['tbl_files', 'kardias'].includes(type))
                return 'files';
            if ([
                'centri_convenzionati_laboratory_analisi',
                'centri_convenzionati_radiologici',
                'centri_convenzionati_specialistici'
            ].includes(type))
                return 'centri';
            return 'default';
        })();
        var defineVisibility = computed(function () {
            var vis = props.row.visibility;
            switch (vis) {
                case 1: return 'Totale';
                case 2: return 'Minima';
                case 3: return 'Parziale';
                default: return 'Non specificato';
            }
        });
        var defineConfidentiality = computed(function () {
            var conf = props.row.assegnazione_confidenzialita;
            switch (conf) {
                case 1: return 'Nessuna Restrizione';
                case 2: return 'Basso';
                case 3: return 'Moderato';
                case 4: return 'Normale';
                case 5: return 'Riservato';
                case 6: return 'Strettamente riservato';
                default: return 'Non specificato';
            }
        });
        function formatDate(dateString) {
            var date = new Date(dateString);
            return date.toLocaleDateString('it-IT');
        }
        function rowAction(type, row) {
            emit("rowActions", type, row);
        }
        function consolPoint(row, clm) {
            try {
                return eval("row." + clm);
            }
            catch (e) {
                console.log(e);
            }
        }
        return function (_ctx, _cache) {
            var _a, _b, _c, _d;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (__props.data.filter == null || ((_a = __props.row[__props.data.filter]) === null || _a === void 0 ? void 0 : _a.toString()) === __props.data.filterValue)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_b = __props.data) === null || _b === void 0 ? void 0 : _b.columns, function (item, index) {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                                (consolPoint(__props.row, item.author) != consolPoint(__props.row, item.patient))
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                                    : _createCommentVNode("", true),
                                _hoisted_3,
                                (_unref(layoutType) === 'default')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createTextVNode(_toDisplayString(consolPoint(__props.row, item.columnNameDescrption)) + " ", 1),
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("p", null, [
                                                _createElementVNode("b", null, _toDisplayString(item.columnNameLabel), 1),
                                                _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1)
                                            ]),
                                            _createElementVNode("p", null, [
                                                _createElementVNode("b", null, _toDisplayString(item.columnNameLabel2), 1),
                                                _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef2)), 1)
                                            ]),
                                            _createElementVNode("p", null, [
                                                _createElementVNode("b", null, _toDisplayString(item.columnNameLabel3), 1),
                                                _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef3)), 1)
                                            ])
                                        ])
                                    ]))
                                    : (_unref(layoutType) === 'centri')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            (index != 2)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createTextVNode(_toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1)
                                                ], 64))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : (_unref(layoutType) === 'contatti')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                (index === 0)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createTextVNode(_toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1)
                                                    ], 64))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1))
                                            ]))
                                            : (_unref(layoutType) === 'visite')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                    _createElementVNode("div", _hoisted_10, _toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1),
                                                    _createElementVNode("div", _hoisted_11, [
                                                        (item.columnNameLabel)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                                                _createElementVNode("b", null, _toDisplayString(item.columnNameLabel), 1),
                                                                _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (item.columnNameLabel2)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                                                                _createElementVNode("b", null, _toDisplayString(item.columnNameLabel2), 1),
                                                                _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef2)), 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (item.columnNameLabel3)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                                                                _createElementVNode("b", null, _toDisplayString(item.columnNameLabel3), 1),
                                                                _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef3)), 1)
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ]))
                                                : (_unref(layoutType) === 'rilevazioni')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                        (index === 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(formatDate(consolPoint(__props.row, item.columnNameDescrption))), 1))
                                                            : _createCommentVNode("", true),
                                                        _createElementVNode("div", _hoisted_17, [
                                                            (item.columnNameLabel)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                                                                    _createElementVNode("b", null, _toDisplayString(item.columnNameLabel), 1),
                                                                    _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1)
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            (item.columnNameLabel2)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                                                                    _createElementVNode("b", null, _toDisplayString(item.columnNameLabel2), 1),
                                                                    _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef2)), 1)
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            (item.columnNameLabel3)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                                                                    _createElementVNode("b", null, _toDisplayString(item.columnNameLabel3), 1),
                                                                    _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef3)), 1)
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ]))
                                                    : (_unref(layoutType) === 'diagnosi')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                            _createElementVNode("div", _hoisted_22, [
                                                                (index === 0)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1))
                                                                    : _createCommentVNode("", true),
                                                                (item.columnNameRef === 'diagnosiDetails.careprovider')
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                                        _createTextVNode(_toDisplayString(item.columnNameLabel) + " ", 1),
                                                                        _createElementVNode("p", _hoisted_25, [
                                                                            _createElementVNode("b", null, _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1)
                                                                        ])
                                                                    ]))
                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                                        _createElementVNode("p", null, [
                                                                            _createElementVNode("b", null, _toDisplayString(item.columnNameLabel), 1),
                                                                            _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1)
                                                                        ])
                                                                    ]))
                                                            ])
                                                        ]))
                                                        : (_unref(layoutType) === 'associati')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                                _createElementVNode("div", _hoisted_28, [
                                                                    (index === 0)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1))
                                                                        : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                                            (item.columnNameDescrption === 'visibility')
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                                                    _createElementVNode("b", null, _toDisplayString(item.columnNameLabel) + ":", 1),
                                                                                    _hoisted_32,
                                                                                    _createElementVNode("span", _hoisted_33, _toDisplayString(defineVisibility.value), 1)
                                                                                ]))
                                                                                : (item.columnNameDescrption === 'assegnazione_confidenzialita')
                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                                                        _createElementVNode("b", null, _toDisplayString(item.columnNameLabel) + ":", 1),
                                                                                        _hoisted_35,
                                                                                        _createElementVNode("span", _hoisted_36, _toDisplayString(defineConfidentiality.value), 1)
                                                                                    ]))
                                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                                                        (item.columnNameLabel)
                                                                                            ? (_openBlock(), _createElementBlock("b", _hoisted_38, _toDisplayString(item.columnNameLabel) + ":", 1))
                                                                                            : _createCommentVNode("", true),
                                                                                        _hoisted_39,
                                                                                        _createElementVNode("span", _hoisted_40, _toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1)
                                                                                    ]))
                                                                        ]))
                                                                ])
                                                            ]))
                                                            : (_unref(layoutType) === 'disponibili')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                                    _createElementVNode("div", _hoisted_42, [
                                                                        (index === 0)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1))
                                                                            : (index === 2)
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                                                    _createElementVNode("b", null, _toDisplayString(item.columnNameLabel) + ":", 1),
                                                                                    _hoisted_45,
                                                                                    _createElementVNode("span", _hoisted_46, _toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1)
                                                                                ]))
                                                                                : _createCommentVNode("", true)
                                                                    ])
                                                                ]))
                                                                : (_unref(layoutType) === 'farmaci')
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                                        _createElementVNode("div", _hoisted_48, [
                                                                            _createTextVNode(_toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1),
                                                                            _hoisted_49,
                                                                            _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameSubDescrption)), 1)
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_50, [
                                                                            (item.columnNameDescrption === 'cp_display')
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                                                                    _createElementVNode("b", null, _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1),
                                                                                    _createElementVNode("p", null, [
                                                                                        _createElementVNode("b", null, _toDisplayString(item.columnNameLabel2), 1),
                                                                                        _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef2)), 1)
                                                                                    ])
                                                                                ]))
                                                                                : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                                                    _createElementVNode("p", null, [
                                                                                        _createElementVNode("b", null, _toDisplayString(item.columnNameLabel), 1),
                                                                                        _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1)
                                                                                    ]),
                                                                                    _createElementVNode("p", null, [
                                                                                        _createElementVNode("b", null, _toDisplayString(item.columnNameLabel2), 1),
                                                                                        _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef2)), 1)
                                                                                    ])
                                                                                ]))
                                                                        ])
                                                                    ]))
                                                                    : (_unref(layoutType) === 'files')
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                                            _createElementVNode("div", _hoisted_54, [
                                                                                (index != 4)
                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                                                        _createTextVNode(_toDisplayString(consolPoint(__props.row, item.columnNameDescrption)) + " " + _toDisplayString(consolPoint(__props.row, item.columnNameDescriptionMobile)) + " ", 1),
                                                                                        (item.columnNameLabel)
                                                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_56, [
                                                                                                _createElementVNode("b", null, [
                                                                                                    _createElementVNode("span", null, _toDisplayString(item.columnNameLabel), 1)
                                                                                                ]),
                                                                                                _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1)
                                                                                            ]))
                                                                                            : _createCommentVNode("", true),
                                                                                        (item.columnNameLabel2)
                                                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_57, [
                                                                                                _createElementVNode("b", null, [
                                                                                                    _createElementVNode("span", null, _toDisplayString(item.columnNameLabel2), 1)
                                                                                                ]),
                                                                                                _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef2)), 1)
                                                                                            ]))
                                                                                            : _createCommentVNode("", true)
                                                                                    ]))
                                                                                    : _createCommentVNode("", true)
                                                                            ])
                                                                        ]))
                                                                        : _createCommentVNode("", true)
                            ]));
                        }), 128)),
                        _createVNode(CollapsibleRowActions, {
                            data: __props.data,
                            onAction: _cache[0] || (_cache[0] = function (n) { return rowAction(n, __props.row); })
                        }, null, 8, ["data"])
                    ]))
                    : _createCommentVNode("", true),
                (__props.data.filter == null || __props.row[__props.data.filter] === __props.data.filterValue)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58))
                    : _createCommentVNode("", true),
                ((_c = __props.data) === null || _c === void 0 ? void 0 : _c.textOrRow)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_d = __props.data) === null || _d === void 0 ? void 0 : _d.columns, function (item, index) {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                                _createElementVNode("div", _hoisted_60, [
                                    (item.columnNameDescrption != undefined)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1))
                                        : _createCommentVNode("", true),
                                    (item.columnNameSubDescrption != undefined)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_62, _toDisplayString(consolPoint(__props.row, item.columnNameSubDescrption)), 1))
                                        : _createCommentVNode("", true),
                                    (item.columnNameRef != undefined)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_63, _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1))
                                        : _createCommentVNode("", true),
                                    (item.columnNameRef2 != undefined)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_64, _toDisplayString(consolPoint(__props.row, item.columnNameRef2)), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default")
            ], 64));
        };
    }
});
